import { render } from "./ProjectsList.vue?vue&type=template&id=9368d110&ts=true"
import script from "./ProjectsList.vue?vue&type=script&lang=ts"
export * from "./ProjectsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__